export const GET_CONTRACTOR_LIST = "GET_CONTRACTOR_LIST";
export const GET_MANAGER_LIST = "GET_MANAGER_LIST";
